import { UserApiBase } from '@/libs/apis/user/base';

export class UserStateApi extends UserApiBase {
  update(stateId, data) {
    return super.put(`state/${stateId}/`, data);
  }
}
